import React from "react";

interface WinnerScreenProps {
  movieName: string;
  resetGame: Function;
}

const WinnerScreen = ({ movieName, resetGame }: WinnerScreenProps) => {
  return (
    <div>
      <div className="mb-4">Nice job! The answer was : {movieName}</div>
      <button
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        onClick={() => resetGame()}
      >
        Reset Game
      </button>
    </div>
  );
};

export default WinnerScreen;
